@if(hasVisibleChildren()) {
  <div class="page-container">
    <ng-container #fieldComponent></ng-container>
  </div>
}